import firebase from 'firebase/app';
import React from 'react';
import DatePicker from 'react-datepicker';
import { Table } from 'react-bootstrap';
import Plot from 'react-plotly.js';

import "react-datepicker/dist/react-datepicker.css";

import withAuthorization from './withAuthorization';


const findEarliest = (observations) => {
  return new Date('01-01-2019 GMT+01:00')
}

const findLatest = (observations) => {
  return new Date()
}

const toDateString = (date) => {
  return (date.getYear() + 1900) + '-' + (date.getMonth() + 1) + '-' + date.getDate()
}

class View extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      'observations': [],
      'fromDate': null,
      'toDate': null
    }

    var query = firebase.database().ref('/observations')

    query.on('value', item => {
      const l = item.val()
      const observations = Object.keys(l).map((id) => {
        return l[id]
      })

      this.setState({
        'observations': observations
      })
    })

    this.renderDates = this.renderDates.bind(this)
    this.renderWeekdays = this.renderWeekdays.bind(this)
    this.renderHours = this.renderHours.bind(this)
  }

  renderDates(dates) {
    const x = Object.keys(dates)
    const y = x.map((date) => {
      return dates[date]
    })

    const sum = y.reduce((total, num) => total + num)

    if ( sum === 0 ) {
      return null
    }

    return (
      <Plot
        data = {[
          {
            x: x,
            y: y,
            type: 'scatter',
            mode: 'lines',
            marker: {color: 'red'},
          },
        ]}
        layout = {
          {
            width: '100%', 
            height: 400, 
            title: 'Observasjoner per dag',
            yaxis: {
              title: 'Antall observasjoner',
              linecolor: 'black',
              linewidth: 1,
              mirror: true
            },
            xaxis: {
              linecolor: 'black',
              linewidth: 1,
              mirror: true
            }
          } 
        }
      />
    );
  }

  renderWeekdays(counts) {
    const sum = counts.reduce((total, num) => total + num)

    if ( sum === 0 ) {
      return null
    }

    return (
      <Plot
        data = {[
          {
            x: ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'],
            y: counts,
            type: 'scatter',
            mode: 'lines',
            marker: {color: 'blue'},
          },
        ]}
        layout = {
          {
            width: '100%', 
            height: 400, 
            title: 'Observasjoner per ukedag',
            yaxis: {
              title: 'Antall observasjoner',
              linecolor: 'black',
              linewidth: 1,
              mirror: true
            },
            xaxis: {
              linecolor: 'black',
              linewidth: 1,
              mirror: true
            }
          } 
        }
      />
    );
  }

  renderHours(counts) {
    const sum = counts.reduce((total, num) => total + num)

    if ( sum === 0 ) {
      return null
    }

    return (
      <Plot
        data = {[
          {
            x: [...Array(24).keys()],
            y: counts,
            type: 'scatter',
            mode: 'lines',
            marker: {color: 'blue'},
          },
        ]}
        layout = {
          {
            width: '100%', 
            height: 400, 
            title: 'Observasjoner per time',
            yaxis: {
              title: 'Antall observasjoner',
              linecolor: 'black',
              linewidth: 1,
              mirror: true
            },
            xaxis: {
              linecolor: 'black',
              linewidth: 1,
              mirror: true
            }
          } 
        }
      />
    );
  }

  render() {
    const observations = this.state.observations

    var startDate = this.state.startDate ? this.state.startDate : findEarliest(observations)
    var endDate = this.state.endDate ? this.state.endDate : findLatest(observations)

    var dates = {}
    var date = new Date(startDate.getTime())

    while ( date <= endDate ) {
      dates[toDateString(date)] = 0
      date.setDate(date.getDate() + 1)
    }

    var weekdays = [...Array(7).keys()].map(() => {return 0})
    var hours = [...Array(24).keys()].map(() => {return 0})

    var countries = {}
    var total = 0

    for ( var i = 0; i < observations.length; i++ ) {
      const country = observations[i]['countryCode']
      const date = new Date(observations[i]['timestamp'])

      if ( !(date >= startDate && date <= endDate) ) {
        continue;
      }

      if ( !countries[country] ) {
        countries[country] = 0
      }

      dates[toDateString(date)] += 1
      weekdays[date.getDay()] += 1
      hours[date.getHours()] += 1
      countries[country] += 1
      total += 1
    }

    countries = Object.keys(countries).map((name, idx) => {
      return (
        <tr key={'country_' + idx}>
          <td style={{textAlign: 'center'}}>#</td>
          <td>{name} ({countries[name]})</td>
        </tr>
      )
    })

    return (
      <div>
        <ViewNav />
        <div style={{width: '80%', margin: '0 auto'}}>
          <div style={{marginTop: '20px', 'marginBottom': '20px', 'textAlign': 'center'}}>
            <DatePicker
              selected={this.state.startDate}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onChange={(event) => this.setState({'startDate': new Date(event)})}
              selectsStart
            />
            &nbsp;-&nbsp;
            <DatePicker 
              selected={this.state.endDate}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onChange={(event) => this.setState({'endDate': new Date(event)})}
              selectsEnd
            />
          </div>
          <div>
            <Table striped bordered style={{fontSize: '14px'}}>
              <tbody>
              <tr>
                <th style={{width: '5%', textAlign: 'center'}}>#</th>
                <th>Alle ({total})</th>
              </tr>
              {countries}
              </tbody>
            </Table>
          </div>
          <div style={{marginTop: '20px', textAlign: 'center'}}>
            {this.renderDates(dates)}
          </div>
          <div style={{marginTop: '20px', textAlign: 'center'}}>
            {this.renderWeekdays(weekdays)}
          </div>
          <div style={{marginTop: '20px', textAlign: 'center'}}>
            {this.renderHours(hours)}
          </div>
        </div>
      </div>
    )
  }
}

const ViewNav = () =>
  <nav className="navbar navbar-expand-lg navbar-light bg-light navbar-collapse">
    <a className="navbar-brand" href="#">NHO Transport</a>
    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarNavDropdown">
      <ul className="navbar-nav">
        <li className="nav-item active">
          <a className="nav-link" href="/register">Registrer ny observasjon<span className="sr-only">(current)</span></a>
        </li>
      </ul>
    </div>
  </nav>

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(View);


// WEBPACK FOOTER //
// ./src/components/View.js